<template>
  <div id="page-wrap" v-if="loggedIn">
    <div class="container content-wrap">
      <div class="row">
        <section>
          <div class="offers">
            <BoardItem v-for="item in filteredBoards" :key="item" :item="item" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BoardItem from './BoardItem/index'
export default {
  name: 'state-board',
  data () {
    return {
    }
  },
  components: { BoardItem },
  computed: {
    ...mapGetters(['loggedIn', 'filteredBoards'])
  },
  mounted () {
    this.$store.dispatch('filterBoards', 'filter')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Board.vue